import { useEffect, useState } from "react";

/**
 * Returns the current visual viewport height, updating when it changes (e.g. the
 * mobile on-screen keyboard opening/closing). Falls back to `window.innerHeight`
 * when the Visual Viewport API is unavailable, and is SSR-safe.
 */
export function useVisualViewportHeight() {
  const [height, setHeight] = useState(() =>
    typeof window === "undefined"
      ? 0
      : (window.visualViewport?.height ?? window.innerHeight),
  );

  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) {
      const onResize = () => setHeight(window.innerHeight);
      window.addEventListener("resize", onResize);
      return () => window.removeEventListener("resize", onResize);
    }
    const onResize = () => setHeight(vv.height);
    vv.addEventListener("resize", onResize);
    onResize();
    return () => vv.removeEventListener("resize", onResize);
  }, []);

  return height;
}
